"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SETTINGS = void 0;
var helpers_1 = require("../../client/helpers");
var settings_fragments_1 = require("./settings.fragments");
exports.GET_SETTINGS = "\n  query GetSettings {\n    settings {\n      ...SettingsFragment\n    }\n  }\n  " + settings_fragments_1.SETTINGS_FRAGMENT + "\n";
//# sourceMappingURL=settings.queries.js.map